import { useRef, useEffect } from "react";
import { Eraser } from "lucide-react";

export function SignaturePad({ value, onChange }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#1F2D7A";
    if (value) {
      const img = new Image();
      img.onload = () => ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      img.src = value;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - rect.left, y: p.clientY - rect.top };
  };

  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = pos(e); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d", { willReadFrequently: true });
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(canvasRef.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    onChange("");
  };

  return (
    <div className="mt-1">
      <div className="relative border border-curtron-line rounded-md bg-white">
        <canvas
          ref={canvasRef}
          width={520}
          height={140}
          className="w-full h-[140px] touch-none rounded-md cursor-crosshair"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
          data-testid="signature-canvas"
        />
        <button type="button" onClick={clear} data-testid="signature-clear"
          className="absolute top-1.5 right-1.5 inline-flex items-center gap-1 text-[11px] text-curtron-sub bg-white/90 border border-curtron-line rounded px-1.5 py-1 hover:bg-curtron-bg">
          <Eraser className="w-3 h-3" /> Clear
        </button>
      </div>
      <p className="text-[11px] text-curtron-muted mt-1">Sign above using your mouse or finger.</p>
    </div>
  );
}
